<div #containerPieChart class="pie-chart-container"></div>
